const hotel = {
  availableMealPlans: "Mga Magagamit na Plano ng Pagkain", // translated 
  availableRoomsTypes: "Mga Uri ng Kwarto na Magagamit", // translated 
  cancellationPolicy: "Patakaran sa Pagkansela", // translated 
  cancellationRules: "Mga Panuntunan sa Pagkansela", // translated 
  freeCancellationAvailable: "Libreng Pagkansela", // translated 
  nonRefundable: "Hindi Maibabalik", // translated 
  priceFor: "Presyo para sa", // translated 
  nights: "mga gabi", // translated 
  totalPrice: "Kabuuang presyo", // translated 
  seeAvailability: "Tingnan ang Availability", // translated 
  myProfile: "Aking Profile", // translated 
  travelTrust: "Tiwala sa Paglalakbay", // translated 
  signIn: "Mag-sign In", // translated 
  searchNow: "Maghanap Ngayon", // translated 
  policy: "Patakaran", // translated 
  cxlRules: "Mga Panuntunan ng CXL", // translated 
  room: "silid", // translated 
  cxlPolicy: "Patakaran ng CXL", // translated 
  beddingType: "Uri ng Higaan", // translated 
  hotelName: "Pangalan ng Hotel", // translated 
  reservationDate: "Petsa ng Pagrereserba", // translated 
  maxPax: "Max Pax", // translated 
};


export default hotel;
